export const TOGGLE_FULLSCREEN = 'TOGGLE_FULLSCREEN';
export const SET_IS_HEADER_FIXED = 'SET_IS_HEADER_FIXED';
export const TURN_OFF_FULLSCREEN = 'TURN_OFF_FULLSCREEN';
export const SET_LIST_TYPE = 'SET_LIST_TYPE';
export const SHOW_TOAST = 'SHOW_TOAST';
export const HIDE_TOAST = 'HIDE_TOAST';
export const SHOW_TO_TOP_COMPONENT = 'SHOW_TO_TOP_COMPONENT';
export const SET_MOBILE = 'SET_MOBILE';
export const RESET_FOLDER_CHILDREN_COUNT = 'RESET_FOLDER_CHILDREN_COUNT';
export const ADD_PAGE_FOLDER_CHILDREN_COUNT = 'ADD_PAGE_FOLDER_CHILDREN_COUNT';
export const SET_THEME = 'SET_THEME';
export const SET_WINDOW_SIZE = 'SET_WINDOW_SIZE';
export const TOGGLE_TODOS_PANEL = 'TOGGLE_TODOS_PANEL';
export const SHOW_TODOS_PANEL = 'SHOW_TODOS_PANEL';
export const CLOSE_TODOS_PANEL = 'CLOSE_TODOS_PANEL';
export const CLOSE_SELECT_DIALOG = "CLOSE_SELECT_DIALOG";
export const OPEN_SELECT_DIALOG = "OPEN_SELECT_DIALOG";
export const SET_IS_EMBED = "SET_IS_EMBED";
export const SET_IS_EMBED_WORDPRESS = "SET_IS_EMBED_WORDPRESS";
export const SET_IS_PREVIEW = "SET_IS_PREVIEW";
export const SET_IS_VIDEO = "SET_IS_VIDEO";
export const SET_IS_EMBED_HEADER_HIDDEN = "SET_IS_EMBED_HEADER_HIDDEN";
export const SET_IS_EMBED_PRINT_ENABLED = "SET_IS_EMBED_PRINT_ENABLED";
export const SET_IS_FULL_WIDTH = "SET_IS_FULL_WIDTH";
export const SET_NOTE_FONT = "SET_NOTE_FONT";
export const SET_IS_SHARE_ACCESS_UPDATING = "SET_IS_SHARE_ACCESS_UPDATING";
export const SET_IS_SHARE_PASSWORD_UPDATING = "SET_IS_SHARE_PASSWORD_UPDATING";
export const TOGGLE_OUTLINES = "TOGGLE_OUTLINES";
export const SET_IS_SHOW_OUTLINES = "SET_IS_SHOW_OUTLINES";
export const SET_IS_SHOW_SEARCH = "SET_IS_SHOW_SEARCH";
export const SET_IS_SOCKET_CONNECTED = "SET_IS_SOCKET_CONNECTED";
export const SET_IS_BRANDING_THEME_DISABLED = "SET_IS_BRANDING_THEME_DISABLED";

export function toggleFullscreen() {
  return {
    type: TOGGLE_FULLSCREEN
  };
}

export function setIsHeaderFixed(value) {
  return {
    type: SET_IS_HEADER_FIXED,
    value
  };
}

export function turnOffFullscreen() {
  return {
    type: TURN_OFF_FULLSCREEN
  };
}

export function setListType(type) {
  return {
    type: SET_LIST_TYPE,
    listType: type
  };
}

export function showToast({id, text, position}) {
  return {
    type: SHOW_TOAST,
    id,
    text,
    position
  };
}

export function hideToast({id}) {
  return {
    type: HIDE_TOAST,
    id
  };
}

export function showToTopComponent(value) {
  return {
    type: SHOW_TO_TOP_COMPONENT,
    value
  };
}

export function setIsShareAccessUpdating(value) {
  return {
    type: SET_IS_SHARE_ACCESS_UPDATING,
    value
  }
}

export function setIsSharePasswordUpdating(value) {
  return {
    type: SET_IS_SHARE_PASSWORD_UPDATING,
    value
  }
}

export function setMobile(value) {
  return {
    type: SET_MOBILE,
    value
  };
}

export function resetFolderChildrenCount() {
  return {
    type: RESET_FOLDER_CHILDREN_COUNT
  };
}

export function addPageFolderChildrenCount() {
  return {
    type: ADD_PAGE_FOLDER_CHILDREN_COUNT
  };
}

export function setTheme(theme) {
  return {
    type: SET_THEME,
    theme
  };
}

export function setIsBrandingThemeDisabled(value: boolean) {
  return {
    type: SET_IS_BRANDING_THEME_DISABLED,
    value,
  }
}

export function setWindowSize({width, height}) {
  return {
    type: SET_WINDOW_SIZE,
    width,
    height
  };
}

export function showTodosPanel() {
  return {
    type: SHOW_TODOS_PANEL
  };
}

export function toggleTodosPanel() {
  return {
    type: TOGGLE_TODOS_PANEL
  };
}

export function closeTodosPanel() {
  return {
    type: CLOSE_TODOS_PANEL
  };
}

export function openSelectDialog() {
  return {
    type: OPEN_SELECT_DIALOG
  };
}

export function closeSelectDialog() {
  return {
    type: CLOSE_SELECT_DIALOG
  };
}

export function setIsEmbed(value) {
  return {
    type: SET_IS_EMBED,
    value,
  }
}

export function setIsEmbedWordpress(value) {
  return {
    type: SET_IS_EMBED_WORDPRESS,
    value,
  }
}

export function setIsPreview(value) {
  return {
    type: SET_IS_PREVIEW,
    value,
  }
}

export function setIsVideo(value) {
  return {
    type: SET_IS_VIDEO,
    value,
  }
}

export function setIsEmmbedHeaderHidden(value) {
  return {
    type: SET_IS_EMBED_HEADER_HIDDEN,
    value,
  }
}

export function setIsEmbedPrintEnabled(value) {
  return {
    type: SET_IS_EMBED_PRINT_ENABLED,
    value,
  }
}

export function setIsFullWidth(value) {
  return {
    type: SET_IS_FULL_WIDTH,
    value,
  }
}

export function setNoteFont(value) {
  return {
    type: SET_NOTE_FONT,
    value,
  }
}

export function toggleOutlines() {
  return {
    type: TOGGLE_OUTLINES,
  }
}

export function setIsShowOutlines(value) {
  return {
    type: SET_IS_SHOW_OUTLINES,
    value,
  }
}

export function setIsShowSearch(value) {
  return {
    type: SET_IS_SHOW_SEARCH,
    value,
  }
}

export function setIsSocketConnected(value) {
  return {
    type: SET_IS_SOCKET_CONNECTED,
    value,
  }
}
